import { createSlice } from "@reduxjs/toolkit";

const holidayPackageSlice = createSlice({
  name: "holidayPackage",
  initialState: {
    holidayPackage: null,
    editingHolidayPackage: null,
    holidayPackageList: null,
    availability: null,
  },
  reducers: {
    setHolidayPackage: (state, action) => {
      state.holidayPackage = action.payload
    },
    clearHolidayPackage: (state) => {
      state.holidayPackage = null
    },
    setHolidayPackageList: (state, action) => {
      state.holidayPackageList = action.payload
    },
    setEditingHolidayPackage: (state, action) => {
      state.editingHolidayPackage = action.payload
    },
    setAvailability: (state, action) => {
      state.availability = action.payload
    },
  },
});

export const { setHolidayPackage, clearHolidayPackage, setHolidayPackageList, setEditingHolidayPackage, setAvailability } = holidayPackageSlice.actions;

export default holidayPackageSlice.reducer;

export const selectCurrentHolidayPackage = (state) => state.persistedReducer.holidayPackage?.holidayPackage ?? null;
export const selectHolidayPackageList = (state) => state.persistedReducer.holidayPackage?.holidayPackageList ?? null;
export const selectEditingHolidayPackage = (state) => state.persistedReducer.holidayPackage?.editingHolidayPackage ?? null;
export const selectAvailability = (state) => state.persistedReducer.holidayPackage?.availability ?? null;

